<div
  class="card modern-card full-width"
>
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Autofill Form 3310</h1>
      </div>
    </div>
  </div>

  <div class="card-body px-4 pb-4">
    <div class="row mb-4" style="text-align: center">
      <div class="col-12">
        <span class="info-text text-info small">
          ** These fields are used to auto-populate and email a form 3310 to the
          proper authorities. If left blank then this feature will be disabled.
          **
        </span>
      </div>
    </div>

    <form
      [formGroup]="agencyForm"
      (ngSubmit)="AddEditClick()"
      autocomplete="off"
      style="margin: 0 auto"
    >
      <!-- Agency Information Section -->
      <div class="row mb-3">
        <div class="col-12">
          <h4 class="mb-3 text-light section-header">
            Official State or local authority where the form 3310 will be sent
          </h4>
        </div>
      </div>

      <!-- Agency Name -->
      <div class="row mb-3">
        <div class="col-12 form-group d-flex align-items-center mb-0">
          <label for="agency_name" class="form-label">
            <span class="text-danger">*</span> Agency Name:
          </label>
          <input
            appCapitalizeFirst
            type="text"
            class="form-control flex-grow-1 text-uppercase"
            formControlName="agency_name"
            id="agency_name"
          />
        </div>
      </div>

      <!-- Address -->
      <div class="row mb-3">
        <div class="col-12 form-group d-flex align-items-center mb-0">
          <label for="address" class="form-label">
            <span class="text-danger">*</span> Address:
          </label>
          <input
            appCapitalizeFirst
            type="text"
            class="form-control flex-grow-1 text-uppercase"
            formControlName="address"
            id="address"
          />
        </div>
      </div>

      <!-- City -->
      <div class="row mb-3">
        <div class="col-12 form-group d-flex align-items-center mb-0">
          <label for="city" class="form-label">
            <span class="text-danger">*</span> City:
          </label>
          <input
            appCapitalizeFirst
            type="text"
            class="form-control flex-grow-1 text-uppercase"
            formControlName="city"
            id="city"
          />
        </div>
      </div>

      <!-- State -->
      <div class="row mb-3">
        <div class="col-12 form-group d-flex align-items-center mb-0">
          <label for="state" class="form-label">
            <span class="text-danger">*</span> State:
          </label>
          <div class="flex-grow-1">
            <ng-select
              [items]="state_list"
              bindLabel="state_name"
              bindValue="state_name"
              [multiple]="false"
              [closeOnSelect]="true"
              appendTo="body"
              class="form-control text-uppercase p-0 border-0 bg-transparent"
              formControlName="state"
              id="state"
            ></ng-select>
          </div>
        </div>
      </div>

      <!-- Agency Email -->
      <div class="row mb-4">
        <div class="col-12 form-group d-flex align-items-center mb-0">
          <label for="agency_email" class="form-label">
            <span class="text-danger">*</span> Agency Email:
          </label>
          <input
            appCapitalizeFirst
            type="text"
            class="form-control flex-grow-1 text-uppercase"
            formControlName="agency_email"
            id="agency_email"
          />
        </div>
      </div>

      <!-- ATF Information Section -->
      <div class="row mb-3 mt-4">
        <div class="col-12">
          <h4 class="mb-3 text-light section-header">
            Default ATF email for Form 3310
          </h4>
        </div>
      </div>

      <!-- ATF Email -->
      <div class="row mb-4">
        <div class="col-12 form-group d-flex align-items-center mb-0">
          <label for="atf_email" class="form-label">
            <span class="text-danger">*</span> ATF Email:
          </label>
          <input
            appCapitalizeFirst
            type="text"
            class="form-control flex-grow-1 text-uppercase"
            formControlName="atf_email"
            id="atf_email"
          />
        </div>
      </div>

      <!-- Form Guidelines -->
      <div class="row mb-4">
        <div class="col-12 text-left text-light small">
          <span class="text-danger">*</span> Denotes required fields
        </div>
      </div>

      <!-- Buttons -->
      <div class="row mt-4">
        <div class="col-md-6 form-group d-flex align-items-center mb-3 mb-md-0">
          <div class="form-label"></div>
          <button
            class="btn green-btn flex-grow-1"
            type="submit"
            style="color: white"
            [disabled]="!agencyForm.valid || !agencyForm.dirty"
          >
            <i class="fa fa-save me-2"></i>Save Settings
          </button>
        </div>

        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <div class="form-label"></div>
          <button
            class="btn grey-btn flex-grow-1"
            type="button"
            style="color: white"
            (click)="clearForm()"
          >
            <i class="fa fa-times me-2"></i>Clear Form
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
